<nz-avatar
  [nzText]="user.username.slice(0, 2).toUpperCase()"
  [ngStyle]="{ backgroundColor: stc(user.username) }"
  class="tw-mr-2"
></nz-avatar>
<span class="tw-text-white tw-text-sm">
  {{ user.clubMember.name }}&nbsp;&nbsp;
  <i nz-icon nzType="caret-down" nzTheme="outline"></i>
</span>
